export const NAME = 'questionResponses'

// Should be equal to the number of questions defined in src/data/EnrollmentQuestions.js
export const NUM_QUESTIONS = 8

// API routes
export const GET_RESPONSES_ROUTE = 'enrollmentResponsesGet'
export const POST_RESPONSES_ROUTE = 'enrollmentResponsesPost'
export const DELETE_RESPONSES_ROUTE = 'enrollmentResponsesDelete'
